import { contextFactory } from '@frontend/design-system';
import { UseSourceTenantsResults } from './useSourceTenants';

export const [DigitalFormsSourceTenantsContext, useDigitalFormsSourceTenantsContext] =
  contextFactory<UseSourceTenantsResults>(
    'useDigitalFormsSourceTenantsContext must be used within a DigitalFormsSourceTenantsContext'
  );
